import React, { useState } from 'react';
import ElbowBall from "../components/ElbowBall";
import modal1 from '../assets/elements/img/tools/tools-analytics.png';
export default ({ isActive }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [interactedWith, setInteractedWith] = useState(null);
  const infoBallData = [
    { 
      title: 'Predictive Analytics',
      copy: 'For Instance: Novartis made an unexpected discovery with an anti-inflammatory drug. This drug was originally approved in 2009 to treat a rare fever disease. In 2017, after years of research, Novartis concluded clinical trials testing the drug’s effects on heart disease risk. The evidence did not lead to an approval.  Surprisingly, though, the evidence suggested a decrease in lung cancer diagnoses and death in the test group.',
      copy2: 'Researchers followed the science and are now testing the drug on patients across various stages of lung cancer.',
      slug: 'predictive-analytics',
      img: modal1
    },
  ]
  const openModal = index => {
    setIsModalOpen(true);
    setInteractedWith(true);
  }

  const closeModal = () => setIsModalOpen(false);
  return (
    <div className="component hide-overflow">
      <div className={`modal ${isModalOpen ? 'modal-opened' : ''}`}>
        <div className="outer-modal" onClick={() => closeModal()}></div>
        <div className="inner-modal">
          <span className="close" onClick={() => closeModal()}>X</span>
            <div>
              <p className="copy">{infoBallData[0].copy}</p>
              <br></br>
              <p className="copy">{infoBallData[0].copy2}</p>
            </div>
        </div>
      </div>
      <ElbowBall isActive={isActive && interactedWith === null} onHandleOpenModal={openModal}/>
    </div>
  );
};
